module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-2-en.fdd69db9282dec2c654fbbf2b4f80853.png";